import {
    SearchCriteria as SearchCriteriaBase,
    SearchResults as SearchResultsBase,
    SearchState as SearchStateBase,
} from "@relode/core";
import { candidates } from "../../../../shared/backend/controllers";

export type SearchState = SearchStateBase<
    candidates.CandidateSearchRequest,
    candidates.CandidateSearchResponse
>;
export type SearchCriteria = SearchCriteriaBase<candidates.CandidateSearchRequest>;
export type SearchResults = SearchResultsBase<candidates.CandidateSearchResponse>;

export const initialSearchState: SearchState = {
    searching: false,
    hasError: false,
    error: undefined,
    isRefined: false,
    searchCriteria: {
        pageIndex: 1,
        pageSize: 25,
    },
    searchResults: {} as Required<Partial<SearchResults>>,
};
